"use client";
import { getUserId } from '@/app/api/auth/[...nextauth]/route';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

/**
 * 执行顺序的问题，在useEffect中使用useIsLoggedIn的返回值时，可能还没有初始化
 * 建议明确判断true/false/undefined
 */
export function useIsLoggedIn() {
  const [logged, setLogged] = useState<boolean | undefined>(undefined);
  const pathname = usePathname();

  useEffect(() => {
    const checkLoginStatus = async () => {
      setLogged(await isLoggedIn());
    };
    checkLoginStatus();
  }, [pathname]);

  return logged; // 返回状态值（可能为 null | boolean）
}


export async function isLoggedIn() {
  const userId = await getUserId();
  return !!userId;
}